<div class="p-grid">
    <div class="p-col-12">

        <p-toast></p-toast>

        <div class="card">
            <p-toolbar styleClass="p-mb-4">
                <ng-template pTemplate="left">
                    <button pButton pRipple label="{{ 'label.novo' | translate }}" icon="pi pi-plus" class="p-button-success p-mr-2 p-mb-2" (click)="openNew()" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                </ng-template>

                <ng-template pTemplate="right">
                    <button pButton pRipple label="{{ 'label.exportar' | translate }}" icon="pi pi-upload" class="p-button-help p-mb-2" (click)="downloadFile()"></button>
                </ng-template>
            </p-toolbar>

            <p-table #dt [value]="bancos" [columns]="cols" [rows]="10" [paginator]="true" [globalFilterFields]="['codBanco','nmeBanco']"
                     [(selection)]="selectedBancos" [rowHover]="true" dataKey="id"
                     styleClass="p-datatable-customers"
                     currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [showCurrentPageReport]="true">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <h5 class="p-m-0">{{ 'banco.titulo' | translate }}</h5>
                        <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                    </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="codBanco">{{ 'banco.codigo' | translate }} <p-sortIcon field="codBanco"></p-sortIcon></th>
                        <th pSortableColumn="nmeBanco">{{ 'banco.nome' | translate }} <p-sortIcon field="nmeBanco"></p-sortIcon></th>
                        <th></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-banco>
                    <tr>
                        <td><span class="p-column-title" style="text-align: center;">Codigo Banco</span>
                            {{banco.codBanco}}
                        </td>
                        <td><span class="p-column-title" style="text-align: center;">Nome Banco</span>
                            {{banco.nmeBanco}}
                        </td>
                        <td>
                            <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2" (click)="editBanco(banco)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                            <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-warning" (click)="deleteBanco(banco)" *ngIf="perfil != null && perfil.nmePerfil === 'ADMTIVIT'"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{ 'label.totalde' | translate }} {{bancos ? bancos.length : 0 }} {{ 'banco.bancos' | translate }}.
                    </div>
                </ng-template>
            </p-table>
        </div>

        <p-dialog [(visible)]="bancoDialog" [style]="{width: '450px'}" header="{{ 'banco.detalhes' | translate }}" [modal]="true" styleClass="p-fluid">
            <ng-template pTemplate="content">
                <div class="p-field">
                    <label for="name">{{ 'banco.codigo' | translate }}</label>
                    <input type="text" pInputText id="codBanco" [(ngModel)]="banco.codBanco" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !banco.codBanco">Cï¿½digo do banco ï¿½ obrigatï¿½rio.</small>
                </div>
                <div class="p-field">
                    <label for="name">{{ 'banco.nome' | translate }}</label>
                    <input type="text" pInputText id="name" [(ngModel)]="banco.nmeBanco" required autofocus />
                    <small class="p-invalid" *ngIf="submitted && !banco.nmeBanco">Nome do banco ï¿½ obrigatï¿½rio.</small>
                </div>
            </ng-template>
            <ng-template pTemplate="footer">
                <button pButton pRipple label="{{ 'label.cancelar' | translate }}" icon="pi pi-times" class="p-button-text" (click)="hideDialog()" ></button>
                <button pButton pRipple label="{{ 'label.salvar' | translate }}" icon="pi pi-check" class="p-button-text" (click)="saveBanco()"></button>
            </ng-template>
        </p-dialog>

        <p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
    </div>
</div>
